import apiClient from './client';

export interface OnboardingRequest {
  botToken: string;
  businessName: string;
  defaultLanguage: string;
  supportedLanguages: string[];
  serviceTypeNames?: string[];
  telegramId: number;
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  languageCode?: string | null;
}

export interface OnboardingTokens {
  accessToken: string;
  accessTokenTtlSeconds: number;
  refreshToken: string;
  refreshTokenTtlSeconds: number;
}

export interface OnboardingTenant {
  id: number;
  botUsername: string;
  slug: string;
  businessName: string;
  subscriptionPlan: string;
}

export interface OnboardingResponse {
  tokens: OnboardingTokens;
  tenant: OnboardingTenant;
  newTenant: boolean;
  serviceTypes: { id: number; name: string }[];
}

export async function registerBusiness(data: OnboardingRequest): Promise<OnboardingResponse> {
  const res = await apiClient.post('/v1/onboarding/register', data);
  return res.data.data;
}
